export default __webpack_public_path__ + "static/brush-stroke-green-15dcbd2c56c532b77114e92f80b256c0.svg";